'use strict';

export class DonationShortcode {
	constructor() {
		this.addEvents();
	}

	addEvents() {
		let selectCurrency = document.querySelector('select[name="user_paying_currency"]');
		if (selectCurrency) {
			let selectedValue = selectCurrency.value;
			setTimeout(() => {
				// Skip if geo-preselection is active (user hasn't manually selected)
				if (sessionStorage.getItem('levcharity_user_selected_currency') === 'true') {
					selectCurrency.value = selectedValue;
				}
			}, 2000)
		}
	}
}
